import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import axiosInstant from "../../../api";
import { callApi, ISelection } from "./helper";
import { getEmbed, distributionSelections } from "../../../api/endpoints";
import { DistributionHeader } from "./distributionHeader";
import { DistributionHandler } from "./distributionHandler";
import { DistributionBody } from "./distributionBody";
import { IVideo } from "../../admin/videos/hooks/useFetchVideos";
import { WhiteBackground } from "../../../components/WhiteBackground";
import { MainContainer } from "../../../components/ContentWrapper";

export const SelectDistribution = () => {
  const { projectId, groupId } = useParams();

  const [group, setGroup] = useState<any>({});
  const [files, setFiles] = useState<Array<IVideo>>([]);
  const [selections, setSelections] = useState<Array<ISelection>>([]);

  const fetchSelections = async () => {
    const url = distributionSelections(Number(projectId), Number(groupId));
    const data = await callApi(url);
    if (data?.rows?.length) setSelections(data.rows);
  };

  const fetchGroup = async (id: number) => {
    const data = await callApi(getEmbed(id));
    if (data) {
      setGroup(data);
      setFiles(data.files);
      if (data.files?.length) fetchSelections();
    }
  };

  useEffect(() => {
    if (groupId) fetchGroup(parseInt(groupId, 10));
  }, [groupId]);

  const saveSelection = async (selection: ISelection) => {
    const data = {
      ...selection,
      fileId: selection.s3_file_id,
      channelId: selection.channel_id,
      subChannelId: selection.sub_channel_id,
    };
    await axiosInstant.post(
      distributionSelections(Number(projectId), Number(groupId)),
      data
    );
  };

  const submitChanges = async () => {
    const promises = [] as Array<any>;
    selections.forEach((selection) => {
      if (selection.isDirty) promises.push(saveSelection(selection));
    });
    await Promise.all(promises);
  };

  const bodyProps = { group, files, selections, setSelections };
  return (
    <WhiteBackground>
      <MainContainer>
        <DistributionHeader group={group} />
        <div className="mt-5">
          <Stack direction="row" alignItems="top">
            <Box
              height="auto"
              maxWidth="auto"
              flexGrow={1}
              sx={{
                overflow: "hidden",
                padding: "0px",
                margin: "0px",
              }}
            >
              <DistributionBody {...bodyProps} />
              <DistributionHandler handleSubmit={submitChanges} />
            </Box>
          </Stack>
        </div>
      </MainContainer>
    </WhiteBackground>
  );
};
